import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

import { CHECKBOX_RADIUS_PX } from 'theme/shape';

const CheckboxIndeterminate = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 18 18" sx={{ borderRadius: CHECKBOX_RADIUS_PX }} {...props}>
            <rect width="18" height="18" x="0" y="0" />
            <rect width="8" height="2.5" x="5" y="7.75" fill="#fff" rx="1.25" />
        </SvgIcon>
    );
};

export default CheckboxIndeterminate;
